module.exports = __webpack_public_path__ + "static/img/logo_2.60b7cb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/logo_2.png
// module id = WX3x
// module chunks = 1